import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _657036f3 = () => interopDefault(import('../../../pages/activity.vue' /* webpackChunkName: "pages/activity" */))
const _73d5f2b6 = () => interopDefault(import('../../../pages/chatbot-preview.vue' /* webpackChunkName: "pages/chatbot-preview" */))
const _79ffe9ec = () => interopDefault(import('../../../pages/commands.vue' /* webpackChunkName: "pages/commands" */))
const _ab45a998 = () => interopDefault(import('../../../pages/commissions.vue' /* webpackChunkName: "pages/commissions" */))
const _018715b0 = () => interopDefault(import('../../../pages/consultation-scripts.vue' /* webpackChunkName: "pages/consultation-scripts" */))
const _10f90964 = () => interopDefault(import('../../../pages/crm-opportunities.vue' /* webpackChunkName: "pages/crm-opportunities" */))
const _237baa2e = () => interopDefault(import('../../../pages/diff.vue' /* webpackChunkName: "pages/diff" */))
const _1b99973a = () => interopDefault(import('../../../pages/email-preview.vue' /* webpackChunkName: "pages/email-preview" */))
const _27de0b3c = () => interopDefault(import('../../../pages/employer-plans.vue' /* webpackChunkName: "pages/employer-plans" */))
const _08981c5c = () => interopDefault(import('../../../pages/employer-report.vue' /* webpackChunkName: "pages/employer-report" */))
const _274cc064 = () => interopDefault(import('../../../pages/employers.vue' /* webpackChunkName: "pages/employers" */))
const _3cbbab39 = () => interopDefault(import('../../../pages/enroll-thank-you.vue' /* webpackChunkName: "pages/enroll-thank-you" */))
const _0b5d6bd1 = () => interopDefault(import('../../../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _1e01d790 = () => interopDefault(import('../../../pages/intake.vue' /* webpackChunkName: "pages/intake" */))
const _399828ee = () => interopDefault(import('../../../pages/keep-plans/index.vue' /* webpackChunkName: "pages/keep-plans/index" */))
const _6c4a558c = () => interopDefault(import('../../../pages/link-login.vue' /* webpackChunkName: "pages/link-login" */))
const _28d7a835 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _70e0ca4a = () => interopDefault(import('../../../pages/magic-redirect-error.vue' /* webpackChunkName: "pages/magic-redirect-error" */))
const _4df3b0aa = () => interopDefault(import('../../../pages/mistake.vue' /* webpackChunkName: "pages/mistake" */))
const _7dbebc74 = () => interopDefault(import('../../../pages/print-window.vue' /* webpackChunkName: "pages/print-window" */))
const _c2deeef2 = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _9d355e84 = () => interopDefault(import('../../../pages/schedule/index.vue' /* webpackChunkName: "pages/schedule/index" */))
const _328f780c = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _24345607 = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _4f75a5f5 = () => interopDefault(import('../../../pages/summary/index.vue' /* webpackChunkName: "pages/summary/index" */))
const _1641b9ad = () => interopDefault(import('../../../pages/summary-scripts.vue' /* webpackChunkName: "pages/summary-scripts" */))
const _e085de7e = () => interopDefault(import('../../../pages/survey/index.vue' /* webpackChunkName: "pages/survey/index" */))
const _1ebd8808 = () => interopDefault(import('../../../pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _62feb516 = () => interopDefault(import('../../../pages/email/client-email-consultation.vue' /* webpackChunkName: "pages/email/client-email-consultation" */))
const _132e0851 = () => interopDefault(import('../../../pages/email/client-survey-consultation.vue' /* webpackChunkName: "pages/email/client-survey-consultation" */))
const _252bc15e = () => interopDefault(import('../../../pages/email/email-consultation.vue' /* webpackChunkName: "pages/email/email-consultation" */))
const _823bbd7e = () => interopDefault(import('../../../pages/email/email-verify.vue' /* webpackChunkName: "pages/email/email-verify" */))
const _14c0c842 = () => interopDefault(import('../../../pages/email/employer-report.vue' /* webpackChunkName: "pages/email/employer-report" */))
const _ae75b5f0 = () => interopDefault(import('../../../pages/email/light-summary.vue' /* webpackChunkName: "pages/email/light-summary" */))
const _07f351e6 = () => interopDefault(import('../../../pages/email/link-login.vue' /* webpackChunkName: "pages/email/link-login" */))
const _3d392cf8 = () => interopDefault(import('../../../pages/email/otp.vue' /* webpackChunkName: "pages/email/otp" */))
const _293cc324 = () => interopDefault(import('../../../pages/email/pdf-summary.vue' /* webpackChunkName: "pages/email/pdf-summary" */))
const _73b60508 = () => interopDefault(import('../../../pages/email/pre-consult-survey.vue' /* webpackChunkName: "pages/email/pre-consult-survey" */))
const _0dd54f90 = () => interopDefault(import('../../../pages/email/reset-password.vue' /* webpackChunkName: "pages/email/reset-password" */))
const _077323ff = () => interopDefault(import('../../../pages/email/summary.vue' /* webpackChunkName: "pages/email/summary" */))
const _3f9680b0 = () => interopDefault(import('../../../pages/email/support.vue' /* webpackChunkName: "pages/email/support" */))
const _6f96d8e3 = () => interopDefault(import('../../../pages/email/task-done.vue' /* webpackChunkName: "pages/email/task-done" */))
const _41ca7109 = () => interopDefault(import('../../../pages/email/test.vue' /* webpackChunkName: "pages/email/test" */))
const _01c4e755 = () => interopDefault(import('../../../pages/email/zen-summary.vue' /* webpackChunkName: "pages/email/zen-summary" */))
const _64cc7d7b = () => interopDefault(import('../../../pages/survey/aep.vue' /* webpackChunkName: "pages/survey/aep" */))
const _50dc8f06 = () => interopDefault(import('../../../pages/survey/completion.vue' /* webpackChunkName: "pages/survey/completion" */))
const _7a91f2cf = () => interopDefault(import('../../../pages/survey/demographics.vue' /* webpackChunkName: "pages/survey/demographics" */))
const _5f4e777c = () => interopDefault(import('../../../pages/survey/drugs.vue' /* webpackChunkName: "pages/survey/drugs" */))
const _0123344a = () => interopDefault(import('../../../pages/survey/income.vue' /* webpackChunkName: "pages/survey/income" */))
const _bd808474 = () => interopDefault(import('../../../pages/survey/landing.vue' /* webpackChunkName: "pages/survey/landing" */))
const _14e0244f = () => interopDefault(import('../../../pages/survey/new.vue' /* webpackChunkName: "pages/survey/new" */))
const _442f26b2 = () => interopDefault(import('../../../pages/survey/pharmacies.vue' /* webpackChunkName: "pages/survey/pharmacies" */))
const _acda53c8 = () => interopDefault(import('../../../pages/survey/plans/index.vue' /* webpackChunkName: "pages/survey/plans/index" */))
const _4a553511 = () => interopDefault(import('../../../pages/survey/providers.vue' /* webpackChunkName: "pages/survey/providers" */))
const _2d39bdb4 = () => interopDefault(import('../../../pages/survey/soa.vue' /* webpackChunkName: "pages/survey/soa" */))
const _bc64973c = () => interopDefault(import('../../../pages/survey/step-by-step.vue' /* webpackChunkName: "pages/survey/step-by-step" */))
const _3c82cbd5 = () => interopDefault(import('../../../pages/survey/summary.vue' /* webpackChunkName: "pages/survey/summary" */))
const _f938fcde = () => interopDefault(import('../../../pages/survey/welcome.vue' /* webpackChunkName: "pages/survey/welcome" */))
const _95a6981e = () => interopDefault(import('../../../pages/survey/plans/_pids.vue' /* webpackChunkName: "pages/survey/plans/_pids" */))
const _5f546f49 = () => interopDefault(import('../../../pages/group/_slug/index.vue' /* webpackChunkName: "pages/group/_slug/index" */))
const _4ee3c3bc = () => interopDefault(import('../../../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _a0a2a114 = () => interopDefault(import('../../../pages/schedule/_slug.vue' /* webpackChunkName: "pages/schedule/_slug" */))
const _af6e4e50 = () => interopDefault(import('../../../pages/start-enrollment/_pid.vue' /* webpackChunkName: "pages/start-enrollment/_pid" */))
const _dea2bcc6 = () => interopDefault(import('../../../pages/summary/_id.vue' /* webpackChunkName: "pages/summary/_id" */))
const _60f5c975 = () => interopDefault(import('../../../pages/survey/_uid/index.vue' /* webpackChunkName: "pages/survey/_uid/index" */))
const _7b84b116 = () => interopDefault(import('../../../pages/group/_slug/articles.vue' /* webpackChunkName: "pages/group/_slug/articles" */))
const _c01fba6c = () => interopDefault(import('../../../pages/group/_slug/drugs.vue' /* webpackChunkName: "pages/group/_slug/drugs" */))
const _b3a16114 = () => interopDefault(import('../../../pages/group/_slug/faqs.vue' /* webpackChunkName: "pages/group/_slug/faqs" */))
const _a017ab38 = () => interopDefault(import('../../../pages/group/_slug/frame.vue' /* webpackChunkName: "pages/group/_slug/frame" */))
const _85a0c414 = () => interopDefault(import('../../../pages/group/_slug/reports.vue' /* webpackChunkName: "pages/group/_slug/reports" */))
const _01ee10f1 = () => interopDefault(import('../../../pages/group/_slug/videos.vue' /* webpackChunkName: "pages/group/_slug/videos" */))
const _a20d7dbc = () => interopDefault(import('../../../pages/group/_slug/webinars.vue' /* webpackChunkName: "pages/group/_slug/webinars" */))
const _aa690188 = () => interopDefault(import('../../../pages/survey/_uid/activity.vue' /* webpackChunkName: "pages/survey/_uid/activity" */))
const _72f859a2 = () => interopDefault(import('../../../pages/survey/_uid/aep.vue' /* webpackChunkName: "pages/survey/_uid/aep" */))
const _38345049 = () => interopDefault(import('../../../pages/survey/_uid/completion.vue' /* webpackChunkName: "pages/survey/_uid/completion" */))
const _3cedc79b = () => interopDefault(import('../../../pages/survey/_uid/demographics.vue' /* webpackChunkName: "pages/survey/_uid/demographics" */))
const _bcdd0614 = () => interopDefault(import('../../../pages/survey/_uid/drugs.vue' /* webpackChunkName: "pages/survey/_uid/drugs" */))
const _37168fda = () => interopDefault(import('../../../pages/survey/_uid/editor.vue' /* webpackChunkName: "pages/survey/_uid/editor" */))
const _29fce666 = () => interopDefault(import('../../../pages/survey/_uid/enrollment-period.vue' /* webpackChunkName: "pages/survey/_uid/enrollment-period" */))
const _1f7d9a9e = () => interopDefault(import('../../../pages/survey/_uid/health-lifestyle.vue' /* webpackChunkName: "pages/survey/_uid/health-lifestyle" */))
const _eb349b94 = () => interopDefault(import('../../../pages/survey/_uid/income-surcharges.vue' /* webpackChunkName: "pages/survey/_uid/income-surcharges" */))
const _072d197a = () => interopDefault(import('../../../pages/survey/_uid/landing.vue' /* webpackChunkName: "pages/survey/_uid/landing" */))
const _b65c8304 = () => interopDefault(import('../../../pages/survey/_uid/pharmacies.vue' /* webpackChunkName: "pages/survey/_uid/pharmacies" */))
const _5d4337d0 = () => interopDefault(import('../../../pages/survey/_uid/plans/index.vue' /* webpackChunkName: "pages/survey/_uid/plans/index" */))
const _2b4b1876 = () => interopDefault(import('../../../pages/survey/_uid/providers.vue' /* webpackChunkName: "pages/survey/_uid/providers" */))
const _3e58db0f = () => interopDefault(import('../../../pages/survey/_uid/quick-aep.vue' /* webpackChunkName: "pages/survey/_uid/quick-aep" */))
const _e21dd930 = () => interopDefault(import('../../../pages/survey/_uid/soa.vue' /* webpackChunkName: "pages/survey/_uid/soa" */))
const _6429892e = () => interopDefault(import('../../../pages/survey/_uid/step-by-step.vue' /* webpackChunkName: "pages/survey/_uid/step-by-step" */))
const _bb1fb0ee = () => interopDefault(import('../../../pages/survey/_uid/summary.vue' /* webpackChunkName: "pages/survey/_uid/summary" */))
const _2d5e4576 = () => interopDefault(import('../../../pages/survey/_uid/welcome.vue' /* webpackChunkName: "pages/survey/_uid/welcome" */))
const _68dd15a5 = () => interopDefault(import('../../../pages/survey/_uid/plans/_pids.vue' /* webpackChunkName: "pages/survey/_uid/plans/_pids" */))
const _5f30051e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activity",
    component: _657036f3,
    name: "activity"
  }, {
    path: "/chatbot-preview",
    component: _73d5f2b6,
    name: "chatbot-preview"
  }, {
    path: "/commands",
    component: _79ffe9ec,
    name: "commands"
  }, {
    path: "/commissions",
    component: _ab45a998,
    name: "commissions"
  }, {
    path: "/consultation-scripts",
    component: _018715b0,
    name: "consultation-scripts"
  }, {
    path: "/crm-opportunities",
    component: _10f90964,
    name: "crm-opportunities"
  }, {
    path: "/diff",
    component: _237baa2e,
    name: "diff"
  }, {
    path: "/email-preview",
    component: _1b99973a,
    name: "email-preview"
  }, {
    path: "/employer-plans",
    component: _27de0b3c,
    name: "employer-plans"
  }, {
    path: "/employer-report",
    component: _08981c5c,
    name: "employer-report"
  }, {
    path: "/employers",
    component: _274cc064,
    name: "employers"
  }, {
    path: "/enroll-thank-you",
    component: _3cbbab39,
    name: "enroll-thank-you"
  }, {
    path: "/forgot-password",
    component: _0b5d6bd1,
    name: "forgot-password"
  }, {
    path: "/intake",
    component: _1e01d790,
    name: "intake"
  }, {
    path: "/keep-plans",
    component: _399828ee,
    name: "keep-plans"
  }, {
    path: "/link-login",
    component: _6c4a558c,
    name: "link-login"
  }, {
    path: "/login",
    component: _28d7a835,
    name: "login"
  }, {
    path: "/magic-redirect-error",
    component: _70e0ca4a,
    name: "magic-redirect-error"
  }, {
    path: "/mistake",
    component: _4df3b0aa,
    name: "mistake"
  }, {
    path: "/print-window",
    component: _7dbebc74,
    name: "print-window"
  }, {
    path: "/register",
    component: _c2deeef2,
    name: "register"
  }, {
    path: "/schedule",
    component: _9d355e84,
    name: "schedule"
  }, {
    path: "/search",
    component: _328f780c,
    name: "search"
  }, {
    path: "/settings",
    component: _24345607,
    name: "settings"
  }, {
    path: "/summary",
    component: _4f75a5f5,
    name: "summary"
  }, {
    path: "/summary-scripts",
    component: _1641b9ad,
    name: "summary-scripts"
  }, {
    path: "/survey",
    component: _e085de7e,
    name: "survey"
  }, {
    path: "/thank-you",
    component: _1ebd8808,
    name: "thank-you"
  }, {
    path: "/email/client-email-consultation",
    component: _62feb516,
    name: "email-client-email-consultation"
  }, {
    path: "/email/client-survey-consultation",
    component: _132e0851,
    name: "email-client-survey-consultation"
  }, {
    path: "/email/email-consultation",
    component: _252bc15e,
    name: "email-email-consultation"
  }, {
    path: "/email/email-verify",
    component: _823bbd7e,
    name: "email-email-verify"
  }, {
    path: "/email/employer-report",
    component: _14c0c842,
    name: "email-employer-report"
  }, {
    path: "/email/light-summary",
    component: _ae75b5f0,
    name: "email-light-summary"
  }, {
    path: "/email/link-login",
    component: _07f351e6,
    name: "email-link-login"
  }, {
    path: "/email/otp",
    component: _3d392cf8,
    name: "email-otp"
  }, {
    path: "/email/pdf-summary",
    component: _293cc324,
    name: "email-pdf-summary"
  }, {
    path: "/email/pre-consult-survey",
    component: _73b60508,
    name: "email-pre-consult-survey"
  }, {
    path: "/email/reset-password",
    component: _0dd54f90,
    name: "email-reset-password"
  }, {
    path: "/email/summary",
    component: _077323ff,
    name: "email-summary"
  }, {
    path: "/email/support",
    component: _3f9680b0,
    name: "email-support"
  }, {
    path: "/email/task-done",
    component: _6f96d8e3,
    name: "email-task-done"
  }, {
    path: "/email/test",
    component: _41ca7109,
    name: "email-test"
  }, {
    path: "/email/zen-summary",
    component: _01c4e755,
    name: "email-zen-summary"
  }, {
    path: "/survey/aep",
    component: _64cc7d7b,
    name: "survey-aep"
  }, {
    path: "/survey/completion",
    component: _50dc8f06,
    name: "survey-completion"
  }, {
    path: "/survey/demographics",
    component: _7a91f2cf,
    name: "survey-demographics"
  }, {
    path: "/survey/drugs",
    component: _5f4e777c,
    name: "survey-drugs"
  }, {
    path: "/survey/income",
    component: _0123344a,
    name: "survey-income"
  }, {
    path: "/survey/landing",
    component: _bd808474,
    name: "survey-landing"
  }, {
    path: "/survey/new",
    component: _14e0244f,
    name: "survey-new"
  }, {
    path: "/survey/pharmacies",
    component: _442f26b2,
    name: "survey-pharmacies"
  }, {
    path: "/survey/plans",
    component: _acda53c8,
    name: "survey-plans"
  }, {
    path: "/survey/providers",
    component: _4a553511,
    name: "survey-providers"
  }, {
    path: "/survey/soa",
    component: _2d39bdb4,
    name: "survey-soa"
  }, {
    path: "/survey/step-by-step",
    component: _bc64973c,
    name: "survey-step-by-step"
  }, {
    path: "/survey/summary",
    component: _3c82cbd5,
    name: "survey-summary"
  }, {
    path: "/survey/welcome",
    component: _f938fcde,
    name: "survey-welcome"
  }, {
    path: "/survey/plans/:pids",
    component: _95a6981e,
    name: "survey-plans-pids"
  }, {
    path: "/group/:slug",
    component: _5f546f49,
    name: "group-slug"
  }, {
    path: "/reset-password/:token?",
    component: _4ee3c3bc,
    name: "reset-password-token"
  }, {
    path: "/schedule/:slug",
    component: _a0a2a114,
    name: "schedule-slug"
  }, {
    path: "/start-enrollment/:pid?",
    component: _af6e4e50,
    name: "start-enrollment-pid"
  }, {
    path: "/summary/:id",
    component: _dea2bcc6,
    name: "summary-id"
  }, {
    path: "/survey/:uid",
    component: _60f5c975,
    name: "survey-uid"
  }, {
    path: "/group/:slug?/articles",
    component: _7b84b116,
    name: "group-slug-articles"
  }, {
    path: "/group/:slug?/drugs",
    component: _c01fba6c,
    name: "group-slug-drugs"
  }, {
    path: "/group/:slug?/faqs",
    component: _b3a16114,
    name: "group-slug-faqs"
  }, {
    path: "/group/:slug?/frame",
    component: _a017ab38,
    name: "group-slug-frame"
  }, {
    path: "/group/:slug?/reports",
    component: _85a0c414,
    name: "group-slug-reports"
  }, {
    path: "/group/:slug?/videos",
    component: _01ee10f1,
    name: "group-slug-videos"
  }, {
    path: "/group/:slug?/webinars",
    component: _a20d7dbc,
    name: "group-slug-webinars"
  }, {
    path: "/survey/:uid/activity",
    component: _aa690188,
    name: "survey-uid-activity"
  }, {
    path: "/survey/:uid/aep",
    component: _72f859a2,
    name: "survey-uid-aep"
  }, {
    path: "/survey/:uid/completion",
    component: _38345049,
    name: "survey-uid-completion"
  }, {
    path: "/survey/:uid/demographics",
    component: _3cedc79b,
    name: "survey-uid-demographics"
  }, {
    path: "/survey/:uid/drugs",
    component: _bcdd0614,
    name: "survey-uid-drugs"
  }, {
    path: "/survey/:uid/editor",
    component: _37168fda,
    name: "survey-uid-editor"
  }, {
    path: "/survey/:uid/enrollment-period",
    component: _29fce666,
    name: "survey-uid-enrollment-period"
  }, {
    path: "/survey/:uid/health-lifestyle",
    component: _1f7d9a9e,
    name: "survey-uid-health-lifestyle"
  }, {
    path: "/survey/:uid/income-surcharges",
    component: _eb349b94,
    name: "survey-uid-income-surcharges"
  }, {
    path: "/survey/:uid/landing",
    component: _072d197a,
    name: "survey-uid-landing"
  }, {
    path: "/survey/:uid/pharmacies",
    component: _b65c8304,
    name: "survey-uid-pharmacies"
  }, {
    path: "/survey/:uid/plans",
    component: _5d4337d0,
    name: "survey-uid-plans"
  }, {
    path: "/survey/:uid/providers",
    component: _2b4b1876,
    name: "survey-uid-providers"
  }, {
    path: "/survey/:uid/quick-aep",
    component: _3e58db0f,
    name: "survey-uid-quick-aep"
  }, {
    path: "/survey/:uid/soa",
    component: _e21dd930,
    name: "survey-uid-soa"
  }, {
    path: "/survey/:uid/step-by-step",
    component: _6429892e,
    name: "survey-uid-step-by-step"
  }, {
    path: "/survey/:uid/summary",
    component: _bb1fb0ee,
    name: "survey-uid-summary"
  }, {
    path: "/survey/:uid/welcome",
    component: _2d5e4576,
    name: "survey-uid-welcome"
  }, {
    path: "/survey/:uid/plans/:pids",
    component: _68dd15a5,
    name: "survey-uid-plans-pids"
  }, {
    path: "/",
    component: _5f30051e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
